import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FileData } from "types/image.type";

interface TransportOrderFilesState {
  filesData: FileData[];
}

const initialState: TransportOrderFilesState = {
  filesData: [],
};

const transportOrderFilesSlice = createSlice({
  name: "transportOrderFiles",
  initialState,
  reducers: {
    setFilesData(
      state,
      action: PayloadAction<FileData[]>
    ) {
      state.filesData = action.payload;
    },

    addFile(
      state,
      action: PayloadAction<FileData>
    ) {
      state.filesData.push(action.payload);
    },

    removeFile(
      state,
      action: PayloadAction<string>
    ) {
      state.filesData = state.filesData.filter(
        (file) => file.id !== action.payload
      );
    },

    resetFilesData(state) {
      state.filesData = [];
    },
  },
});

export const {
  setFilesData,
  addFile,
  removeFile,
  resetFilesData,
} = transportOrderFilesSlice.actions;

export default transportOrderFilesSlice.reducer;
